import styled from 'styled-components';

const Divider = styled.hr`
    border: 0;
    border-top: 1px solid #e8e8e8;
    padding: ${({ margin, top = '1', bottom = '1', insideDrawer }) =>
        insideDrawer ? '1px 100% 1px 0px' : `${margin || top}px 100% ${margin || bottom}px 0px`};
`;

export default Divider;
